import { render, staticRenderFns } from "./SetVip.vue?vue&type=template&id=95de81c6&scoped=true&"
import script from "./SetVip.vue?vue&type=script&lang=js&"
export * from "./SetVip.vue?vue&type=script&lang=js&"
import style0 from "./SetVip.vue?vue&type=style&index=0&id=95de81c6&lang=scss&scoped=true&"
import style1 from "./SetVip.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95de81c6",
  null
  
)

export default component.exports